import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom"; // if you use normal <a> also ok

const MobileMenuScroll = () => {
  const scrollRef = useRef(null);

  useEffect(() => {
    const container = scrollRef.current;
    let isPaused = false;

    // Pause when user touches or scrolls manually
    const stopScroll = () => {
      isPaused = true;
      setTimeout(() => (isPaused = false), 3000);
    };

    container.addEventListener("touchstart", stopScroll);
    container.addEventListener("wheel", stopScroll);

    // Duplicate items once for infinite scrolling
    container.innerHTML += container.innerHTML;

    const autoScroll = () => {
      if (!isPaused) {
        container.scrollLeft += 0.8; // Speed control
      }

      if (container.scrollLeft >= container.scrollWidth / 2) {
        container.scrollLeft = 0; // Restart loop
      }

      requestAnimationFrame(autoScroll);
    };

    requestAnimationFrame(autoScroll);

    return () => {
      container.removeEventListener("touchstart", stopScroll);
      container.removeEventListener("wheel", stopScroll);
    };
  }, []);

  return (
    <div className="auto-menu bg-dark py-2 px-2 d-lg-none mobile-scroll-menu">
      <div ref={scrollRef} className="scroll-container">
        <div className="scroll-items">
          <Link to="/" className="item">
            🏆 Home
          </Link>
          <Link to="/sports" className="item">
            🎯 Sports
          </Link>
          <Link to="/cricket" className="item">
            🏏 Cricket
          </Link>
          <Link to="/football" className="item">
            ⚽ Football
          </Link>
          {/* <Link to="/tennis" className="item">
            🎾 Tennis
          </Link>
          <Link to="/horse-racing" className="item">
            🐎 Racing
          </Link>
          <Link to="/greyhound-racing" className="item">
            🐕 Greyhound
          </Link>
          <Link to="/election" className="item">
            🗳 Election
          </Link> */}
          <Link to="/slots" className="item">
            🎰 Slots
          </Link>
          <Link to="/casino" className="item">
            🎲 Casino
          </Link>
          <Link to="/crash" className="item">
            🎮 Crash
          </Link>
          <Link to="/fishing" className="item">
            🐟 Fishing
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MobileMenuScroll;
